import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  all: unset;
  cursor: pointer;
  width: 32px;
  height: 32px;
  padding: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(42, 42, 42, 1);

  &:hover {
    background: ${shade(0.2, '#ff9000')};
  }
`;
